import React, { Component, useEffect, Fragment } from "react";

import { connect } from 'react-redux'
import Auth from './Auth/Auth';

import { LightTheme, DarkTheme } from "./themes/themes"


class Theme extends Component {

    constructor(props) {
        super(props);
        this.auth = new Auth(this.props.history);

        let theme = this.auth.isAuthenticated() ? this.props.theme : 'light';
        this.state = {
            theme: theme
        };
    }

    componentWillReceiveProps(nextProps) {
        
        let theme = this.auth.isAuthenticated() ? nextProps.theme : 'light';

        this.setState({
            theme: theme
        });
    }

    render() {
        return (
            <Fragment>
                {this.state.theme == "light" &&
                    <LightTheme />
                }
                {this.state.theme == "dark" &&
                    <DarkTheme />
                }
            </Fragment>

        );
    };
};

const mapStateToProps = state => ({
    theme: state.rootReducer.theme
});

export default connect(mapStateToProps)(Theme);